// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Meta rule result model
*/
export class EnrollmentV2RulesMetaRuleResultModel {
    /**
    * @description Rule Type Code to Bypass
    */
    'bypassRuleTypeCode'?: string | null;
    /**
    * @description Rule Code to Bypass
    */
    'bypassRuleCode'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentV2RulesMetaRuleResultModel>> = [
        {
            "name":     "bypassRuleTypeCode",
            "baseName": "bypassRuleTypeCode",
            "type":     "string"
        },
        {
            "name":     "bypassRuleCode",
            "baseName": "bypassRuleCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentV2RulesMetaRuleResultModel.attributeTypeMap;
    }
}
